"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BusinessUnit = exports.BusinessUnitComponent = void 0;

/**
 * A Business Unit Component (Feature on the BE) represents a component within a Business Unit.
 *
 * The original use case originated from the need to differentiate the component
 * within a Business Unit during onboarding.
 *
 * This is a copy of the BusinessUnitFeature enum in commons.
 * TODO: We need better code splitting on web-api-ts-client before we can import values directly.
 * Currently the generated JS file is too big.
 */
var BusinessUnitComponent;
exports.BusinessUnitComponent = BusinessUnitComponent;

(function (BusinessUnitComponent) {
  BusinessUnitComponent["REGISTRY"] = "REGISTRY";
  BusinessUnitComponent["WEDDINGS"] = "WEDDINGS";
  BusinessUnitComponent["WEDDING_WEBSITE"] = "WEDDING_WEBSITE";
  BusinessUnitComponent["WEDDING_CHECKLIST"] = "WEDDING_CHECKLIST";
  BusinessUnitComponent["WEDDING_GUEST_LIST"] = "WEDDING_GUEST_LIST";
  BusinessUnitComponent["WEDDING_PLANNING"] = "WEDDING_PLANNING";
  BusinessUnitComponent["INSPIRATION"] = "INSPIRATION";
  BusinessUnitComponent["INVITATIONS"] = "INVITATIONS";
  BusinessUnitComponent["SAVE_THE_DATE"] = "SAVE_THE_DATE";
  BusinessUnitComponent["CHANGE_THE_DATE"] = "CHANGE_THE_DATE";
  BusinessUnitComponent["THANK_YOU_CARDS"] = "THANK_YOU_CARDS";
  BusinessUnitComponent["DAY_OF_PAPER"] = "DAY_OF_PAPER";
  BusinessUnitComponent["HOLIDAY"] = "HOLIDAY";
  BusinessUnitComponent["MARKETPLACE"] = "MARKETPLACE";
  BusinessUnitComponent["STORE"] = "STORE";
  BusinessUnitComponent["WEDDING_ALBUM"] = "WEDDING_ALBUM";
})(BusinessUnitComponent || (exports.BusinessUnitComponent = BusinessUnitComponent = {}));

var BusinessUnit;
exports.BusinessUnit = BusinessUnit;

(function (BusinessUnit) {
  BusinessUnit["INVITATIONS"] = "INVITATIONS";
  BusinessUnit["MARKETPLACE"] = "MARKETPLACE";
  BusinessUnit["MARKETPLACE_VENDORS"] = "MARKETPLACE_VENDORS";
  BusinessUnit["WEDDINGS"] = "WEDDINGS";
  BusinessUnit["WEDDING_REGISTRY"] = "WEDDING_REGISTRY";
  BusinessUnit["STORE"] = "STORE";
  BusinessUnit["PHOTOBOOK"] = "PHOTOBOOK";
  BusinessUnit["INSPIRATION"] = "INSPIRATION";
})(BusinessUnit || (exports.BusinessUnit = BusinessUnit = {}));